import { Box, Button, Typography } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
const ListMessages = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack vertically on mobile, row on larger screens
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" }, // Align items properly for both layouts
          gap: { xs: 2, sm: 0 }, // Add gap when stacked, remove when in row
          mb: 3,
        }}
      >
        <Typography
          fontSize={"18px"}
          fontWeight={500}
          sx={{ mb: { xs: 1, sm: 0 } }}
        >
          Messages List
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            navigate(`/home/add-message`);
          }}
          sx={{ width: { xs: "100%", sm: "auto" } }} // Full width on mobile, auto on larger screens
        >
          Add Message
        </Button>
      </Box>
    </div>
  );
};

export default ListMessages;
